import {TenantResponseBody} from '@dms/api/shared';

export const tenantResponseMock: TenantResponseBody = {
  id: '603e8d2e-7956-45c9-9075-37318e77c61c',
  country: 'CZE',
  currency: 'CZK',
  type: 'selfEmployed',
  publicContacts: {
    phoneNumber: {
      countryCode: 'CZE',
      prefix: '+420',
      number: '724157024',
    },
    emailAddress: 'josef.novak@seznam.cz',
    website: 'http://carvago.localhost:4200/settings/tenant-profile',
  },
  contactInformation: {
    registrationNumber: 'asdasd',
    vatNumber: '12345',
    companyName: 'trading company',
    address: {
      street: 'Radimovaa',
      city: 'Praha 6',
      zipCode: '169 00',
      country: 'CZE',
      state: '',
    },
    selfEmployedInformation: {
      firstName: 'test',
      lastName: 'test1',
      titleBefore: 'd',
      titleAfter: 'd',
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '+420',
        number: '724157024',
      },
      emailAddress: 'dwdw@dwdw.cz',
    },
    fileNumber: 'CZ123031323aasda',
  },
  contactPersons: [
    {
      firstName: 'martin',
      lastName: 'aaa',
      role: 'admin',
      phoneNumber: {
        countryCode: 'CZE',
        prefix: '',
        number: '',
      },
      emailAddress: null,
      isPrimary: true,
    },
  ],
  billingInformation: [
    {
      id: '01876d95-ebcc-4c31-9b3e-a1e4d27d4bfe',
      isPrimary: false,
      billingName: 'Fakturační údaje Visionary2',
      contactInformation: {
        registrationNumber: '11111111',
        vatNumber: 'CZ48906564',
        companyName: 'TEAS',
        address: {
          street: 'Čs. dobrovolců',
          city: 'Teplice 1',
          zipCode: '415 01',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'juhzgt',
      },
      bankAccounts: [
        {
          bankName: 'martyho banka',
          isPrimary: false,
          accountName: 'martyho Account',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: null,
          iban: null,
        },
        {
          bankName: 'ČSOB',
          isPrimary: false,
          accountName: 'Eurový účet',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: null,
          iban: null,
        },
        {
          bankName: 'ČSOB',
          isPrimary: false,
          accountName: 'Dolarový účet',
          accountNumber: '670100-2211504021/6210',
          currency: 'USD',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'a',
          lastName: 'a',
          dateOfBirth: '2023-12-25T23:00:00.000Z',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: '11111',
          validUntil: '2023-12-25T23:00:00.000Z',
          issuedBy: 'martyes',
          identificationNumber: '22222',
        },
        {
          isPrimary: false,
          firstName: 'martin',
          lastName: 'slaby',
          dateOfBirth: '2023-12-12T23:00:00.000Z',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: null,
          validUntil: '2023-12-26T23:00:00.000Z',
          issuedBy: 'asd',
          identificationNumber: '24234234234',
        },
        {
          isPrimary: false,
          firstName: 'jmeno',
          lastName: 'prijmeni',
          dateOfBirth: '2023-12-19',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: '234234234',
          validUntil: '2023-12-29',
          issuedBy: 'jmeno1',
          identificationNumber: '214324234',
        },
      ],
    },
    {
      id: '037d1df0-165f-4560-9206-957589e8678a',
      isPrimary: false,
      billingName: 'Frajeři pro system',
      contactInformation: {
        registrationNumber: '01303431',
        vatNumber: 'CZ01303431',
        companyName: 'Honzik Vrabel sro',
        address: {
          street: 'Mělník',
          city: 'Mělníčék',
          zipCode: '27601',
          country: 'SVK',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'fghfh',
      },
      bankAccounts: [
        {
          bankName: 'Jméno banky',
          isPrimary: false,
          accountName: 'Jméno účtuxx',
          accountNumber: '2696973001/0300',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
        {
          bankName: 'Mbank',
          isPrimary: false,
          accountName: 'účet',
          accountNumber: '111333/2700',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '06742e7b-bb62-4528-8d4c-76a58ba5fc80',
      isPrimary: false,
      billingName: 'Test billing info',
      contactInformation: {
        registrationNumber: 'registration',
        vatNumber: 'vat number',
        companyName: 'Company name',
        address: {
          street: 'Some kind of street',
          city: 'Praha',
          zipCode: '12345',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'number',
      },
      bankAccounts: [
        {
          bankName: 'bank name',
          isPrimary: false,
          accountName: 'jmeeeno',
          accountNumber: 'numba',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '0ac25dd8-8bfc-4408-9124-99792bf51c73',
      isPrimary: false,
      billingName: 'ahojky',
      contactInformation: {
        registrationNumber: '3000',
        vatNumber: null,
        companyName: 'ahojkyCau',
        address: {
          street: 'praha1',
          city: 'praha',
          zipCode: '30é00',
          country: 'AFG',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'SADA',
          isPrimary: true,
          accountName: 'praha1',
          accountNumber: '2000145399/0800',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '1131b9d9-35f1-4629-953f-3ae33b81cf71',
      isPrimary: false,
      billingName: 'moje billing info222',
      contactInformation: {
        registrationNumber: '111111',
        vatNumber: '2342234',
        companyName: 'billing inf2',
        address: {
          street: 'Lidečská',
          city: 'Praha 517',
          zipCode: '155 21',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '234233333',
      },
      bankAccounts: [
        {
          bankName: null,
          isPrimary: false,
          accountName: 'martyho Account',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '1282921d-998b-47ff-ad35-83038ee72fcc',
      isPrimary: false,
      billingName: 'Nová BI',
      contactInformation: {
        registrationNumber: '9123456789444',
        vatNumber: 'CZ91234567894',
        companyName: 'Nová',
        address: {
          street: 'Dělnická',
          city: 'Praha 7',
          zipCode: '170 00',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '123654',
      },
      bankAccounts: [
        {
          bankName: 'csob',
          isPrimary: true,
          accountName: 'velkejww',
          accountNumber: '721843235/0300',
          currency: 'CZK',
          swift: 'CEKOCZPP',
          iban: 'CZ92 0300 0000 0007 2184 3235',
        },
        {
          bankName: 'Mbank',
          isPrimary: false,
          accountName: 'Eurový účet',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'martin',
          lastName: 'slaby',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '13d6e231-0db3-47a3-98b7-132bfa6df9cb',
      isPrimary: false,
      billingName: 'fgfg',
      contactInformation: {
        registrationNumber: '721843235',
        vatNumber: 'CZ72184323',
        companyName: 'dgdh',
        address: {
          street: 'dfggdh',
          city: 'ghfgh',
          zipCode: '27601',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'dgg',
      },
      bankAccounts: [
        {
          bankName: '0300',
          isPrimary: false,
          accountName: 'dfhfgh',
          accountNumber: '721843235',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '1814c541-c3d4-45a2-a884-f5cb1818d11d',
      isPrimary: false,
      billingName: 'My Testing Corporation',
      contactInformation: {
        registrationNumber: '12345678',
        vatNumber: 'vatnumber',
        companyName: 'Company',
        address: {
          street: 'Somewhere',
          city: 'London',
          zipCode: 'Code',
          country: 'GBR',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'Fio Bank',
          isPrimary: false,
          accountName: 'Account name',
          accountNumber: '9877554321/0010',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Ondrej',
          lastName: 'Gálik',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_DRIVING_LICENSE',
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: '185f5f0c-9854-4338-975d-22a7a1c4e110',
      isPrimary: false,
      billingName: null,
      contactInformation: {
        registrationNumber: 'registration-number-RU2222222',
        vatNumber: 'CZ07673507-e636f1a9-232d-4f56-a5c2-a573f8c10405',
        companyName: 'Team2 Branch',
        address: {
          street: '',
          city: '',
          zipCode: '',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [],
      deputyPersons: [],
    },
    {
      id: '1967bb81-e580-45d3-96be-d6d8ed9b91e2',
      isPrimary: false,
      billingName: 'dhdhdt',
      contactInformation: {
        registrationNumber: 'dathdhahda',
        vatNumber: 'djgdgjdjg',
        companyName: 'djdgjdj',
        address: {
          street: 'jfjjj',
          city: 'jjgj',
          zipCode: 'fsfjsfjjsffj',
          country: 'SVK',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'fffjfjs',
      },
      bankAccounts: [
        {
          bankName: '657575u5',
          isPrimary: false,
          accountName: 'hbhbhbbh',
          accountNumber: 'hbhbhhb',
          currency: 'EUR',
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'norole',
          lastName: 'mjkjkj',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: '1f4f6637-5eda-4431-949b-69ccf463b0d1',
      isPrimary: false,
      billingName: 'nhfnfhn',
      contactInformation: {
        registrationNumber: 'nhgnghng',
        vatNumber: 'ghnghnghn',
        companyName: 'ghnghnghn',
        address: {
          street: 'ghnghnghhn',
          city: 'ghnhgng',
          zipCode: 'ghnghngh',
          country: 'AIA',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'česká',
          isPrimary: false,
          accountName: 'gngfn',
          accountNumber: '721843235/0300',
          currency: 'CZK',
          swift: 'CEKOCZPP',
          iban: 'CZ9203000000000721843235',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '1f90d8a9-bdfe-4429-8f5a-9fb7be9bd9ed',
      isPrimary: false,
      billingName: 'Biling information name',
      contactInformation: {
        registrationNumber: '24412141',
        vatNumber: '24412141',
        companyName: '24412141',
        address: {
          street: 'sdgdfg',
          city: 'dfgsdf',
          zipCode: '27601',
          country: 'CZE',
          state: 'ceskarepublika',
        },
        selfEmployedInformation: null,
        fileNumber: '24412141',
      },
      bankAccounts: [
        {
          bankName: 'jmeno bankovniho uctu',
          isPrimary: true,
          accountName: 'jmeno uctu',
          accountNumber: 'cislo uctu',
          currency: 'CZK',
          swift: 'string',
          iban: 'string',
        },
      ],
      deputyPersons: [
        {
          isPrimary: true,
          firstName: 'string',
          lastName: 'string',
          dateOfBirth: 'string',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: 'string',
          validUntil: 'string',
          issuedBy: 'string',
          identificationNumber: 'string',
        },
      ],
    },
    {
      id: '202298db-a5db-4df0-bedc-688e8ae87b9e',
      isPrimary: false,
      billingName: 'New amazing billing name',
      contactInformation: {
        registrationNumber: 'Reg.number',
        vatNumber: 'NewVat.number',
        companyName: 'Company name',
        address: {
          street: 'Some kind of street',
          city: 'Praha',
          zipCode: '12345',
          country: 'AZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'Another file number',
      },
      bankAccounts: [
        {
          bankName: 'new bank name',
          isPrimary: false,
          accountName: 'New account name',
          accountNumber: 'new account number',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '20312c71-576e-4302-a848-1c108c7a910c',
      isPrimary: false,
      billingName: 'Testovací údaje',
      contactInformation: {
        registrationNumber: '25097521',
        vatNumber: 'CZ25097521',
        companyName: 'MONE s.r.o.',
        address: {
          street: 'Luční 214/85',
          city: 'Mladá Boleslav',
          zipCode: '15749',
          country: 'ALA',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'Moneta',
          isPrimary: false,
          accountName: 'Účet',
          accountNumber: '748-0077620021/0710',
          currency: 'CZK',
          swift: 'CNBACZPP',
          iban: 'CZ84 0710 0007 4800 7762 0021',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '20871946-80dc-4dc1-a053-94bc3964755b',
      isPrimary: false,
      billingName: '!DSBillingname (TygrStromovka)',
      contactInformation: {
        registrationNumber: '06898327',
        vatNumber: 'CZ699002719',
        companyName: 'TYGR U STROMOVKY s.r.o.',
        address: {
          street: 'Tygr (street)',
          city: 'Stromovka (city)',
          zipCode: '10000 (zip',
          country: 'CZE',
          state: 'Tygrov (state/province)',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: false,
          accountName: '!DSAccNameBil (TygrStromovka)',
          accountNumber: '2601876824/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ6220100000002601876824',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '23115e4b-ca04-401e-95bf-824d6aab9a34',
      isPrimary: false,
      billingName: 'v',
      contactInformation: {
        registrationNumber: '1',
        vatNumber: '12',
        companyName: 'x',
        address: {
          street: 'cc',
          city: 'v',
          zipCode: '4',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: '2',
          isPrimary: false,
          accountName: 'x',
          accountNumber: '1',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '276d40f5-0c06-4975-ba23-0d2f3e9b704e',
      isPrimary: false,
      billingName: 'David Test 2',
      contactInformation: {
        registrationNumber: '21154545_15165',
        vatNumber: '5165165111',
        companyName: 'Company Something ',
        address: {
          street: 'Průběžná',
          city: 'Brno',
          zipCode: 'Code',
          country: 'CZE',
          state: 'Jihomoravský',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'Equa Bank',
          isPrimary: true,
          accountName: 'Asd',
          accountNumber: '123456789/6100',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '31c75480-acd9-4fde-8d2b-ddf608fd29e7',
      isPrimary: false,
      billingName: 'Carvago, s.r.o.',
      contactInformation: {
        registrationNumber: '07641109',
        vatNumber: 'CZ07641109',
        companyName: 'Carvago, s.r.o.',
        address: {
          street: 'Dělnická',
          city: 'Mělník',
          zipCode: '11000',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'seef',
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: true,
          accountName: 'Some account',
          accountNumber: '2601876824/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ6220100000002601876824',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Kateřina',
          lastName: 'Kramar',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '357ad3f4-c689-4347-add4-661d20e9a3d9',
      isPrimary: false,
      billingName: 'TEST adres',
      contactInformation: {
        registrationNumber: '29126169',
        vatNumber: 'CZ29126169',
        companyName: 'EAG',
        address: {
          street: 'Pseudoadresa',
          city: 'Praha',
          zipCode: '10001',
          country: 'CZE',
          state: 'Praha 1',
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'CNB',
          isPrimary: false,
          accountName: 'UCET',
          accountNumber: '47620661/0710',
          currency: 'CZK',
          swift: 'CNBACZPP',
          iban: 'CZ28 0710 0000 0000 4762 0661',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '36009a2a-8684-41a6-991b-172db60b339d',
      isPrimary: false,
      billingName: '!ZORO Solutions s.r.o.',
      contactInformation: {
        registrationNumber: '02205271',
        vatNumber: 'CZ02205271',
        companyName: '!ZORO Solutions s.r.o.',
        address: {
          street: '!Street!',
          city: '!City!',
          zipCode: '!12345!',
          country: 'CZE',
          state: '!CZ!',
        },
        selfEmployedInformation: null,
        fileNumber: '!File number 123',
      },
      bankAccounts: [
        {
          bankName: '!Zoro banka!',
          isPrimary: false,
          accountName: '!Zoro účet!',
          accountNumber: '2696973001/5500',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '46805f2f-817e-4a2d-b008-9192021e7772',
      isPrimary: false,
      billingName: 'jdrgdrg',
      contactInformation: {
        registrationNumber: 'erf',
        vatNumber: ',kjmh',
        companyName: 'hjmhj',
        address: {
          street: 'hjmh',
          city: 'hjm',
          zipCode: 'hjm',
          country: 'AZE',
          state: 'tzhez',
        },
        selfEmployedInformation: null,
        fileNumber: 'etzh',
      },
      bankAccounts: [
        {
          bankName: 'tzh',
          isPrimary: true,
          accountName: 'rht',
          accountNumber: 'tzzth',
          currency: null,
          swift: '',
          iban: 'zthtz',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '48eabdad-1fe8-429c-9b0c-019727cb226b',
      isPrimary: false,
      billingName: 'Billing name',
      contactInformation: {
        registrationNumber: 'CZ06418147',
        vatNumber: 'CZ06418147',
        companyName: 'Mercedes-Benz',
        address: {
          street: 'Bavorská 2666/16',
          city: 'Praha',
          zipCode: '15500',
          country: 'CZE',
          state: 'Czech republic',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ06418147',
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: false,
          accountName: 'Účet',
          accountNumber: '2550690703/2600',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '4a2fbb7b-f2b4-4a65-861d-74d6dfa5b19a',
      isPrimary: false,
      billingName: 'David Test 2',
      contactInformation: {
        registrationNumber: '564619819889',
        vatNumber: '1211212sdfsdfsd',
        companyName: 'Funny Company s.r.o.',
        address: {
          street: 'Adresasdfsdfdsdffsdfsdfdsfds',
          city: '15616516',
          zipCode: '156165',
          country: 'CZE',
          state: 'jihomoravský ',
        },
        selfEmployedInformation: null,
        fileNumber: '121212sdfsdsdffds',
      },
      bankAccounts: [
        {
          bankName: 'dasasdsad',
          isPrimary: false,
          accountName: 'pro Jendu',
          accountNumber: 'asdasdas',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'pro',
          lastName: 'Jendu',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: '4d27672f-44aa-43fd-9a2f-3b85aff852d1',
      isPrimary: false,
      billingName: 'sss',
      contactInformation: {
        registrationNumber: '1212',
        vatNumber: '1212',
        companyName: 'FDFDF',
        address: {
          street: '12',
          city: '1212',
          zipCode: '1212',
          country: 'ARM',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'aaa',
          isPrimary: false,
          accountName: 'aaa',
          accountNumber: '1212',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '4fff453c-4fef-4ed9-8506-6a80131fca30',
      isPrimary: false,
      billingName: 'Billing Name - Mercedes',
      contactInformation: {
        registrationNumber: '9123456789',
        vatNumber: '           ',
        companyName: 'Mc laren',
        address: {
          street: 'Platnéřská 88/9',
          city: 'Praha',
          zipCode: '11000',
          country: 'CZE',
          state: 'Praha',
        },
        selfEmployedInformation: null,
        fileNumber: 'B 23947/MSPH Městský soud v Praze',
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: true,
          accountName: 'FIO',
          accountNumber: '2601876824/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ6220100000002601876824',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '51a31016-6ee8-429c-8c36-704563cd84ff',
      isPrimary: false,
      billingName: 'Pěknej novej účet',
      contactInformation: {
        registrationNumber: '98755555555',
        vatNumber: 'srgnhgf',
        companyName: 'dfvhjmngbf',
        address: {
          street: 'l.k,jmhn',
          city: '.km',
          zipCode: '.k<m n',
          country: 'BGR',
          state: 'frf',
        },
        selfEmployedInformation: null,
        fileNumber: 'ghh bfvdcx',
      },
      bankAccounts: [
        {
          bankName: null,
          isPrimary: false,
          accountName: 'Bank account test',
          accountNumber: '63 1500 1894 1211 2008 3024 0000',
          currency: 'PLN',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '555bf942-f9df-4398-8ead-642c6d0dcce2',
      isPrimary: false,
      billingName: 'Andrés Test 2',
      contactInformation: {
        registrationNumber: '21154545_0.2',
        vatNumber: '2221',
        companyName: 'Car Dealers',
        address: {
          street: '5th av.',
          city: 'London',
          zipCode: 'Code',
          country: 'GBR',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ17673555',
      },
      bankAccounts: [
        {
          bankName: 'IBANKA',
          isPrimary: false,
          accountName: 'Name',
          accountNumber: 'Account',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
        {
          bankName: 'name',
          isPrimary: true,
          accountName: 'account name',
          accountNumber: 'number',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
        {
          bankName: 'bank',
          isPrimary: false,
          accountName: 'Accountname',
          accountNumber: 'number',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Deputy',
          lastName: 'LastName',
          dateOfBirth: '1980-11-11',
          personalIdType: 'ID_TYPE_PASSPORT',
          personalIdNumber: '1111',
          validUntil: '1989-12-11',
          issuedBy: 'asd',
          identificationNumber: '111',
        },
      ],
    },
    {
      id: '55c8e702-0815-4cc3-837f-07659aab7348',
      isPrimary: false,
      billingName: 'tztrgrfgkj,',
      contactInformation: {
        registrationNumber: 'oikujzhtg',
        vatNumber: 'uijzht',
        companyName: 'ikujzht',
        address: {
          street: 'umzjnhb',
          city: 'uijzht',
          zipCode: 'ujzhtzg',
          country: 'ALB',
          state: 'kmjhng',
        },
        selfEmployedInformation: null,
        fileNumber: 'mjhngbf',
      },
      bankAccounts: [
        {
          bankName: 'ujhg',
          isPrimary: false,
          accountName: 'mjhngbfvd',
          accountNumber: ',kmjnhg',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '5d497223-90d7-4bf5-827d-e8daaae0fcea',
      isPrimary: false,
      billingName: 'John Doe d',
      contactInformation: {
        registrationNumber: '202020',
        vatNumber: '987654321',
        companyName: "Buy'n'Ride",
        address: {
          street: 'Long St. ev',
          city: 'Great Channibury',
          zipCode: '1111',
          country: 'BEL',
          state: '111',
        },
        selfEmployedInformation: null,
        fileNumber: '1111',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: false,
          accountName: 'My account name',
          accountNumber: '721843235',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
        {
          bankName: 'ČS',
          isPrimary: false,
          accountName: 'Another account name',
          accountNumber: '111230303',
          currency: null,
          swift: '',
          iban: 'iban',
        },
        {
          bankName: 'KB',
          isPrimary: true,
          accountName: 'Test bane',
          accountNumber: '321312312/1111',
          currency: 'CZK',
          swift: '/',
          iban: '58/',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '67c310dc-54ae-4196-baaa-088376a1bd59',
      isPrimary: false,
      billingName: 'Validní fakturační údaje',
      contactInformation: {
        registrationNumber: '02204222',
        vatNumber: null,
        companyName: 'Společnost1',
        address: {
          street: 'Na Hrázi',
          city: 'PRaha',
          zipCode: '15000',
          country: 'CZE',
          state: 'Praha',
        },
        selfEmployedInformation: null,
        fileNumber: 'soud A',
      },
      bankAccounts: [
        {
          bankName: 'Fio',
          isPrimary: false,
          accountName: 'Fio',
          accountNumber: '2701815623/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ4120100000002701815623',
        },
        {
          bankName: 'CSOB',
          isPrimary: false,
          accountName: 'Banka1',
          accountNumber: '192735/0300',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '6be0ebb6-4325-48d7-bec6-9a6cfbbf1268',
      isPrimary: false,
      billingName: 'Testovací',
      contactInformation: {
        registrationNumber: '24306541',
        vatNumber: null,
        companyName: 'lkj',
        address: {
          street: 'Polní',
          city: 'Ústí',
          zipCode: '41201',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: false,
          accountName: 'testovací účet',
          accountNumber: '2601876824/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ6220100000002601876824',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '741ce223-ba75-4f4e-b697-0409bd5964a8',
      isPrimary: false,
      billingName: 'Biling information name',
      contactInformation: {
        registrationNumber: '63067516',
        vatNumber: '64453521',
        companyName: '31566662',
        address: {
          street: 'sdgdfg',
          city: 'dfgsdf',
          zipCode: '27601',
          country: 'CZE',
          state: 'ceskarepublika',
        },
        selfEmployedInformation: null,
        fileNumber: '08422238',
      },
      bankAccounts: [
        {
          bankName: 'jmeno bankovniho uctu',
          isPrimary: true,
          accountName: 'jmeno uctu',
          accountNumber: 'cislo uctu',
          currency: 'CZK',
          swift: 'string',
          iban: 'string',
        },
      ],
      deputyPersons: [
        {
          isPrimary: true,
          firstName: 'string',
          lastName: 'string',
          dateOfBirth: 'string',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: 'string',
          validUntil: 'string',
          issuedBy: 'string',
          identificationNumber: 'string',
        },
      ],
    },
    {
      id: '7c4ab508-9828-4eb8-99cd-43d061bd1ec8',
      isPrimary: false,
      billingName: 'jou test',
      contactInformation: {
        registrationNumber: '12312312',
        vatNumber: '3143124213',
        companyName: 'test',
        address: {
          street: 'na petynce',
          city: 'praha',
          zipCode: '1231222',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'jes',
      },
      bankAccounts: [
        {
          bankName: 'Mbank',
          isPrimary: false,
          accountName: 'jehijee',
          accountNumber: '670100-2211504021/6210',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: '80f0eeaf-2279-4a81-a305-a6c6de3b9543',
      isPrimary: false,
      billingName: 'Best Car Dealer Ever Ltd.',
      contactInformation: {
        registrationNumber: '02209225',
        vatNumber: 'CZ02209225',
        companyName: "Buy'n'Ride",
        address: {
          street: 'Průběžná',
          city: 'Praha',
          zipCode: '649465',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'Big Bank',
          isPrimary: false,
          accountName: '646456',
          accountNumber: '000123-0123150287/0100',
          currency: 'SEK',
          swift: '',
          iban: '',
        },
        {
          bankName: 'Fio',
          isPrimary: true,
          accountName: 'ucet 1',
          accountNumber: '2701815623/2010',
          currency: 'CZK',
          swift: 'FIOBCZPP',
          iban: 'CZ4120100000002701815623',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: '',
          lastName: '',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_PASSPORT',
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: '84be45fa-9af5-48be-aadb-816e400c35c9',
      isPrimary: false,
      billingName: 'Billing Name - Mercedesraa',
      contactInformation: {
        registrationNumber: 'ijzuhtgrr',
        vatNumber: 'nbvcx',
        companyName: 'uijuhgzf',
        address: {
          street: 'zuthgfrd',
          city: 'nghbfzhzgtfr',
          zipCode: 'ujzhtgrfe',
          country: 'AZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'zhtgr',
          isPrimary: false,
          accountName: 'gbfvdfc',
          accountNumber: 'zhgtf',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '8be819ef-7845-45fa-9e7b-4011bfed4bb7',
      isPrimary: false,
      billingName: '12',
      contactInformation: {
        registrationNumber: '12345671',
        vatNumber: 'CZ12345671',
        companyName: 'ghj',
        address: {
          street: 'ghj',
          city: 'ghj',
          zipCode: 'ghj',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'dfg',
          isPrimary: false,
          accountName: 'dfg',
          accountNumber: '721843235/0300',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '9362f1f4-4e7a-47e8-89c5-bb1c6ef3c026',
      isPrimary: false,
      billingName: 'Car Seller Bros',
      contactInformation: {
        registrationNumber: '543432',
        vatNumber: '5432',
        companyName: 'Company name',
        address: {
          street: 'Some kind of street',
          city: 'Praha',
          zipCode: '12345',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: true,
          accountName: 'Account name',
          accountNumber: 'number',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '99766c8a-c550-4f34-914d-55b55ccf56e6',
      isPrimary: false,
      billingName: 'Fakturační údaje 1',
      contactInformation: {
        registrationNumber: '3322113',
        vatNumber: 'CZ3322113',
        companyName: 'Company',
        address: {
          street: 'Street',
          city: 'Brno',
          zipCode: '61601',
          country: 'CZE',
          state: 'Jihomoravský',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ111222',
      },
      bankAccounts: [
        {
          bankName: 'česká',
          isPrimary: true,
          accountName: 'moneta',
          accountNumber: '721843235/0100',
          currency: 'AMD',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'ag',
          lastName: 'adfg',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: '13265487',
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: '9d8e091d-7d02-45d0-a9f3-07a6e66e03b2',
      isPrimary: false,
      billingName: 'S Auto Group, s.r.o.',
      contactInformation: {
        registrationNumber: '25568698',
        vatNumber: 'CZ56',
        companyName: 'S Auto Group, s.r.o.',
        address: {
          street: 'Jánošíkova 3876/7',
          city: 'Hodonín',
          zipCode: '34500',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'FIO',
          isPrimary: false,
          accountName: 'S Auto účet',
          accountNumber: '2550690703/2600',
          currency: 'CZK',
          swift: 'CITICZPX',
          iban: 'CZ72 2600 0000 0025 5069 0703',
        },
      ],
      deputyPersons: [],
    },
    {
      id: '9fcdce4c-7fc3-4692-91dc-078e423e5302',
      isPrimary: false,
      billingName: 'test 2',
      contactInformation: {
        registrationNumber: '124124124',
        vatNumber: '1241214124',
        companyName: 'testyyy',
        address: {
          street: 'na petynce',
          city: 'praha',
          zipCode: '12312',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'jea',
      },
      bankAccounts: [
        {
          bankName: 'Mbank',
          isPrimary: false,
          accountName: 'test',
          accountNumber: '670100-2211504021/6210',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'a4ba6127-e9c9-42ab-be5b-1ba731ffbfb5',
      isPrimary: false,
      billingName: 'This',
      contactInformation: {
        registrationNumber: '1233445',
        vatNumber: '099828233',
        companyName: '12',
        address: {
          street: '111',
          city: '111',
          zipCode: '111',
          country: 'CZE',
          state: '111',
        },
        selfEmployedInformation: null,
        fileNumber: '123',
      },
      bankAccounts: [
        {
          bankName: '123',
          isPrimary: true,
          accountName: 'Account',
          accountNumber: '123',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: '123',
          lastName: '123',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: 'a7430cb3-e7a8-4ff9-bf50-991bea81c5f1',
      isPrimary: false,
      billingName: 'Just Another Company Inc.',
      contactInformation: {
        registrationNumber: '01387804',
        vatNumber: 'CZ01387804',
        companyName: 'Something',
        address: {
          street: 'Down',
          city: 'Oslo',
          zipCode: '27601',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'POOIUQOIHJDKOJQ',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: false,
          accountName: 'Testovací jméno',
          accountNumber: '721843235/0300',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'AAA',
          lastName: 'BBBB',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: 'sdfdsfds',
          validUntil: '2021-04-28',
          issuedBy: '',
          identificationNumber: '',
        },
        {
          isPrimary: false,
          firstName: 'BBBB',
          lastName: 'VVVVVV',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: 'dsdfds',
          validUntil: '2021-04-29',
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: 'a7e07deb-f747-4f5e-8c1a-80ca9ca40476',
      isPrimary: false,
      billingName: 'Billing name',
      contactInformation: {
        registrationNumber: '12345678#2',
        vatNumber: 'testnumber',
        companyName: 'Company',
        address: {
          street: 'Street',
          city: 'City',
          zipCode: 'Code',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'number',
      },
      bankAccounts: [
        {
          bankName: 'Fancy bank name',
          isPrimary: false,
          accountName: 'Fancy account name',
          accountNumber: 'Fancy account number',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'aa3fb606-e891-4f10-8070-40fb7649a742',
      isPrimary: false,
      billingName: null,
      contactInformation: {
        registrationNumber: 'registration-number-CZ06418147',
        vatNumber: 'CZ07673507-9181dbf1-8e55-4993-89e3-e58ac52c8902',
        companyName: 'Bazar',
        address: {
          street: 'Bavorská',
          city: 'Praha',
          zipCode: '155 00',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [],
      deputyPersons: [],
    },
    {
      id: 'bc2aab08-2636-493b-a957-e622b82a9e39',
      isPrimary: false,
      billingName: 'nvkdfdk',
      contactInformation: {
        registrationNumber: 'dndfkvnd',
        vatNumber: '324324',
        companyName: 'dfv dfm v',
        address: {
          street: 'dfv md v',
          city: 'dvs',
          zipCode: '00000',
          country: 'AND',
          state: 'djvdss ',
        },
        selfEmployedInformation: null,
        fileNumber: 'ddvdmv fmd',
      },
      bankAccounts: [
        {
          bankName: 'fdvdfvdf',
          isPrimary: false,
          accountName: 'vdfvdfvdf',
          accountNumber: 'ffvdfv',
          currency: 'CZK',
          swift: 'dfvdfvd',
          iban: 'fdvdfv',
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'bef8506f-e275-4c14-8083-9bbab0f329c0',
      isPrimary: false,
      billingName: '45224',
      contactInformation: {
        registrationNumber: '721843236',
        vatNumber: 'CZ721843236',
        companyName: 'xfghxfgh',
        address: {
          street: 'xfgh',
          city: 'fgh',
          zipCode: '27601',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'dfg',
          isPrimary: false,
          accountName: 'dgdfg',
          accountNumber: '7218432357',
          currency: 'CZK',
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'cc4c23d6-c658-4515-9868-99945264c6b4',
      isPrimary: false,
      billingName: 'Andrés Test',
      contactInformation: {
        registrationNumber: '129129',
        vatNumber: 'VAT NUMBER another',
        companyName: 'Company',
        address: {
          street: 'Finská',
          city: 'Praha',
          zipCode: 'Code',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ17673555_@2',
      },
      bankAccounts: [
        {
          bankName: 'ČSOB',
          isPrimary: false,
          accountName: 'Name',
          accountNumber: '1234567890/0900',
          currency: 'CZK',
          swift: 'swift',
          iban: 'iban',
        },
        {
          bankName: 'cs',
          isPrimary: true,
          accountName: 'Account name',
          accountNumber: '123456789',
          currency: 'CZK',
          swift: '',
          iban: '1231222',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'FirstName',
          lastName: 'LastName',
          dateOfBirth: '2020-10-20',
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: 'id number',
          validUntil: '2010-10-20',
          issuedBy: 'me',
          identificationNumber: 'id number',
        },
      ],
    },
    {
      id: 'ccb194c8-611e-4354-b231-3635170daded',
      isPrimary: false,
      billingName: 'Example s.r.o.',
      contactInformation: {
        registrationNumber: '999990',
        vatNumber: '99909',
        companyName: 'Example s.r.o.',
        address: {
          street: 'Pařížská',
          city: 'Praha',
          zipCode: '11111',
          country: 'ARM',
          state: '111',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'KB',
          isPrimary: true,
          accountName: '123456',
          accountNumber: '666-000',
          currency: 'CZK',
          swift: '12',
          iban: '1234',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Pan',
          lastName: 'Zástupce',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: 'cd9a8d9b-1b47-4c72-a3dd-50f280e7ae6c',
      isPrimary: false,
      billingName: 'České údaje (Billing name)',
      contactInformation: {
        registrationNumber: '48906565',
        vatNumber: null,
        companyName: 'Česko (company name)',
        address: {
          street: 'Česká (street)',
          city: 'České (city)',
          zipCode: '10000 (ZIP)',
          country: 'CZE',
          state: 'Morava (province)',
        },
        selfEmployedInformation: null,
        fileNumber: 'C336897 ',
      },
      bankAccounts: [
        {
          bankName: '',
          isPrimary: false,
          accountName: 'Účet',
          accountNumber: '2696973001/5500',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'd188d642-f7b1-4076-bea4-238b50fbed4c',
      isPrimary: false,
      billingName: 'xxxxxxxxx',
      contactInformation: {
        registrationNumber: 'xxxx',
        vatNumber: 'xxxxx',
        companyName: 'xxxxx',
        address: {
          street: 'xxxxxxx',
          city: 'xxxxxx',
          zipCode: 'xxxxx',
          country: 'CZE',
          state: 'xxxxx',
        },
        selfEmployedInformation: null,
        fileNumber: 'xxxxxxxx',
      },
      bankAccounts: [
        {
          bankName: 'xxxxx',
          isPrimary: false,
          accountName: 'xxxx',
          accountNumber: 'xxxxx',
          currency: 'CZK',
          swift: 'xxxxxxxx',
          iban: 'xxxxx',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Renata',
          lastName: 'Burdová',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: 'd5af9fdf-4968-4c2d-99ad-9e90616aabaa',
      isPrimary: false,
      billingName: 'David Test',
      contactInformation: {
        registrationNumber: 'X21154545',
        vatNumber: 'C45616151',
        companyName: 'Company Inc.',
        address: {
          street: 'Průběžná',
          city: 'Psince',
          zipCode: 'Code',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ17673555654146516',
      },
      bankAccounts: [],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Šmucko ',
          lastName: 'Knoflík',
          dateOfBirth: '2000-10-10',
          personalIdType: 'ID_TYPE_DRIVING_LICENSE',
          personalIdNumber: '1234567891',
          validUntil: '2020-10-10',
          issuedBy: '01.01.2011',
          identificationNumber: '123456789/01011',
        },
        {
          isPrimary: false,
          firstName: 'Brmko',
          lastName: 'Ňufík',
          dateOfBirth: '2000-10-10',
          personalIdType: 'ID_TYPE_DRIVING_LICENSE',
          personalIdNumber: '134835343',
          validUntil: '2020-10-10',
          issuedBy: '01.01.2011',
          identificationNumber: '45648897',
        },
        {
          isPrimary: false,
          firstName: 'Šaško',
          lastName: 'Mračík',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: '786786786',
          validUntil: null,
          issuedBy: null,
          identificationNumber: '8786786',
        },
        {
          isPrimary: false,
          firstName: 'Dupko',
          lastName: 'Ťapík',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: '昕昕',
          lastName: '黄',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: '123456789',
          validUntil: null,
          issuedBy: '吚喔天鸡鸣，扶桑色昕昕。',
          identificationNumber: null,
        },
      ],
    },
    {
      id: 'dc95506b-a788-4704-8879-1270968b9bc5',
      isPrimary: false,
      billingName: 'Testovací údaje',
      contactInformation: {
        registrationNumber: '15267979',
        vatNumber: 'cz15267979',
        companyName: 'test',
        address: {
          street: 'J. Vrby',
          city: 'Duchcov',
          zipCode: '419 01',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: 'tet',
      },
      bankAccounts: [
        {
          bankName: null,
          isPrimary: false,
          accountName: 'Bank account test',
          accountNumber: '63 1500 1894 1211 2008 3024 0000',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'e1b49706-4695-47b7-afdb-059cb10c8ac5',
      isPrimary: false,
      billingName: '789',
      contactInformation: {
        registrationNumber: '21112425',
        vatNumber: 'CZ21112425',
        companyName: 'thjgzjfgh',
        address: {
          street: 'fhkhjk',
          city: '5424',
          zipCode: '27601',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: false,
          accountName: 'uuuuu',
          accountNumber: '721843235/0300',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'e4a54fa2-2091-4d8c-a196-e443bd69cb23',
      isPrimary: false,
      billingName: 'David Test 2',
      contactInformation: {
        registrationNumber: 'dqwdfsfsdfsdfds',
        vatNumber: 'saddsfů)sdfů)sdfů',
        companyName: 'Funny Company s.r.o.',
        address: {
          street: '51651655165',
          city: '15616516',
          zipCode: '156165',
          country: 'MNE',
          state: 'melnik',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'dasasdsad',
          isPrimary: false,
          accountName: 'pro Jendu',
          accountNumber: 'asdasdas',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'pro',
          lastName: 'Jendu',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: '',
          identificationNumber: '',
        },
      ],
    },
    {
      id: 'e537a8dc-bfb1-4444-81e1-d817eaffda70',
      isPrimary: false,
      billingName: 'Billing Name - Carvago name',
      contactInformation: {
        registrationNumber: '21154545',
        vatNumber: 'VAT NUMBER',
        companyName: 'Company',
        address: {
          street: 'Hlavní třída',
          city: 'Praha',
          zipCode: 'Code',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'CZ17673555',
      },
      bankAccounts: [
        {
          bankName: 'CSOB',
          isPrimary: true,
          accountName: 'CSOB',
          accountNumber: '0000021502/0800',
          currency: 'CZK',
          swift: 'SWIFT',
          iban: 'CZ1250516714915692572474',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'aaa',
          lastName: 'asd',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: 'r3232',
          lastName: '3453',
          dateOfBirth: '2015-10-11',
          personalIdType: 'ID_TYPE_PASSPORT',
          personalIdNumber: 'wqerqwrqwer',
          validUntil: '2020-02-12',
          issuedBy: 'sasdfaf',
          identificationNumber: 'qwrewqwrerew',
        },
      ],
    },
    {
      id: 'e56306a7-ebd1-4e60-afc6-276fbd5d5449',
      isPrimary: false,
      billingName: 'Tomáš Mašín',
      contactInformation: {
        registrationNumber: '1234567',
        vatNumber: 'CZ123456',
        companyName: 'Tom a Spol. s.r.o.',
        address: {
          street: 'Dolní',
          city: 'Praha',
          zipCode: '11000',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '666',
      },
      bankAccounts: [
        {
          bankName: 'bank name',
          isPrimary: true,
          accountName: 'name',
          accountNumber: 'Account number',
          currency: 'CZK',
          swift: 'swift',
          iban: '',
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'Jaroslav',
          lastName: 'Franta',
          dateOfBirth: '1940-03-20',
          personalIdType: 'ID_TYPE_DRIVING_LICENSE',
          personalIdNumber: '1234111',
          validUntil: null,
          issuedBy: null,
          identificationNumber: '1234556',
        },
        {
          isPrimary: false,
          firstName: 'Denis',
          lastName: 'Kamrlík',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
        {
          isPrimary: false,
          firstName: 'Alois',
          lastName: 'Jirásek',
          dateOfBirth: null,
          personalIdType: null,
          personalIdNumber: null,
          validUntil: null,
          issuedBy: null,
          identificationNumber: null,
        },
      ],
    },
    {
      id: 'e91eb21f-44e8-466a-862b-1167e4558b6d',
      isPrimary: false,
      billingName: 'Billing Name - Carvago name',
      contactInformation: {
        registrationNumber: 'registration@2#2',
        vatNumber: 'Vat number #2',
        companyName: 'Company',
        address: {
          street: 'Street',
          city: 'City',
          zipCode: 'Code',
          country: 'CZE',
          state: 'State',
        },
        selfEmployedInformation: null,
        fileNumber: 'filenumber',
      },
      bankAccounts: [
        {
          bankName: 'name',
          isPrimary: false,
          accountName: 'name',
          accountNumber: 'number',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'efaa3990-3a1f-469e-8779-efe4e78c23df',
      isPrimary: false,
      billingName: 'Bi',
      contactInformation: {
        registrationNumber: '23445566',
        vatNumber: null,
        companyName: 'Best company',
        address: {
          street: 'Kapr ',
          city: 'Praha',
          zipCode: '10000',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: 'Čs ',
          isPrimary: false,
          accountName: 'Some ',
          accountNumber: '1684591001/5500',
          currency: 'CZK',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [
        {
          isPrimary: false,
          firstName: 'John',
          lastName: 'Doe',
          dateOfBirth: null,
          personalIdType: 'ID_TYPE_ID',
          personalIdNumber: '77378383882',
          validUntil: null,
          issuedBy: 'Mu',
          identificationNumber: '',
        },
      ],
    },
    {
      id: 'f1914ddd-071d-43e9-b63c-67b66c67c79d',
      isPrimary: false,
      billingName: 'moje billing info1',
      contactInformation: {
        registrationNumber: '23423423424',
        vatNumber: '2343234',
        companyName: 'billing info 1',
        address: {
          street: 'Václavkova',
          city: 'Mladá Boleslav 1',
          zipCode: '293 01',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '2333324234234',
      },
      bankAccounts: [
        {
          bankName: null,
          isPrimary: false,
          accountName: 'martyho Account',
          accountNumber: '670100-2211504021/6210',
          currency: 'EUR',
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'f555dda5-e343-4a88-bb87-731794949a13',
      isPrimary: false,
      billingName: 'Bare bil name sdasda',
      contactInformation: {
        registrationNumber: 'Bare reg nr',
        vatNumber: null,
        companyName: 'Bare Comp 123',
        address: {
          street: 'Bare Str',
          city: 'Bare city',
          zipCode: '13370',
          country: 'CZE',
          state: null,
        },
        selfEmployedInformation: null,
        fileNumber: null,
      },
      bankAccounts: [
        {
          bankName: ' xBank',
          isPrimary: true,
          accountName: 'Bare acc ccc',
          accountNumber: '721843235/0300',
          currency: null,
          swift: null,
          iban: null,
        },
      ],
      deputyPersons: [],
    },
    {
      id: 'fdffe719-831a-42ae-995b-1d3c386a2b92',
      isPrimary: false,
      billingName: 'testík',
      contactInformation: {
        registrationNumber: '01303143',
        vatNumber: 'CZ8905290768',
        companyName: 'sdfdf',
        address: {
          street: 'sdfasf',
          city: 'asdfasdf',
          zipCode: '27601',
          country: 'CZE',
          state: '',
        },
        selfEmployedInformation: null,
        fileNumber: '',
      },
      bankAccounts: [
        {
          bankName: 'dghjdhj',
          isPrimary: false,
          accountName: 'dghjhj',
          accountNumber: '721843235/0300',
          currency: null,
          swift: '',
          iban: '',
        },
      ],
      deputyPersons: [],
    },
  ],
};
